import createSagaMiddleware from "redux-saga";
import { applyMiddleware, createStore, compose } from "redux";
import { persistStore } from "redux-persist";
import { persistedReducer } from "./rootReducer";
import rootSaga from "./rootSaga";

const sagaMiddleware = createSagaMiddleware();
const composeEnhancer =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ serialize: true })
    : compose;

const store = createStore(
  persistedReducer,
  composeEnhancer(applyMiddleware(sagaMiddleware))
);

sagaMiddleware.run(rootSaga);
export const persistor = persistStore(store);

if (window.Cypress) {
  window.store = store;
}

export default store;
